module.exports = __webpack_public_path__ + "static/media/faq-hero-image.85f0298d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/faq-hero-image.png
// module id = 1401
// module chunks = 0